import {fetchSafeFlowChallenge} from '@yandex-delivery/order-form/src/api'
import {useConfigContext} from '@yandex-delivery/order-form/src/contexts'
import {useCallback, useRef} from 'react'

export function useSafeFlowAction() {
  const intervalID = useRef<number | null>(null)
  const appConfig = useConfigContext()

  const handleSafeFlowWindow = useCallback((safeFlowWindow: Window | null) => {
    intervalID.current = window.setInterval(() => {
      const isRedirected = !safeFlowWindow?.closed && safeFlowWindow?.location?.origin === window.location.origin
      if (isRedirected) {
        safeFlowWindow?.close()
      }

      if (safeFlowWindow?.closed) {
        if (intervalID.current) {
          clearInterval(intervalID.current)
        }
      }
    }, 100)
  }, [])

  return useCallback(async () => {
    const challengeUrl = await fetchSafeFlowChallenge(appConfig)
    const safeFlowWindow = window.open(challengeUrl, 'safe-flow')
    handleSafeFlowWindow(safeFlowWindow)
  }, [appConfig, handleSafeFlowWindow])
}
